import type { SVGProps } from "react";

const PaymentLine = ({
  className,
  ...props
}: { className?: string } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="115"
      height="219"
      viewBox="0 0 115 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M113.333 0C113.886 0 114.333 0.447708 114.333 1C114.333 1.55228 113.886 2 113.333 2V1V0ZM80.8333 1.00009V9.15527e-05V1.00009ZM5.33337 213L5.33338 212L40.8333 212V213L40.8333 214L5.33337 214L5.33337 213ZM60.8334 193H59.8334V21.0001H60.8334H61.8334V193H60.8334ZM80.8333 1.00009V9.15527e-05L113.333 0V1V2L80.8333 2.00009V1.00009ZM60.8334 21.0001H59.8334C59.8334 9.4021 69.2354 0.00012207 80.8333 9.15527e-05V1.00009V2.00009C70.3399 2.00011 61.8334 10.5067 61.8334 21.0001H60.8334ZM40.8333 213V212C51.3268 212 59.8334 203.493 59.8334 193H60.8334H61.8334C61.8334 204.598 52.4313 214 40.8333 214L40.8333 213Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PaymentLine;
